import { render, staticRenderFns } from "./importSupplier.vue?vue&type=template&id=32de04c6&scoped=true"
import script from "./importSupplier.vue?vue&type=script&lang=js"
export * from "./importSupplier.vue?vue&type=script&lang=js"
import style0 from "./importSupplier.vue?vue&type=style&index=0&id=32de04c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32de04c6",
  null
  
)

export default component.exports